import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useRef, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchCaptchaSolved } from '../user/actions.js';
import { getCurrentLocale } from '../l10n/store.js';
export var useCaptcha = function useCaptcha() {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    captchaToken = _useState2[0],
    setCaptchaToken = _useState2[1];
  var captchaRef = useRef(null);
  var dispatch = useDispatch();
  var currentLocale = useSelector(function (state) {
    return getCurrentLocale(state);
  });
  var currentLanguage = useMemo(function () {
    if (currentLocale === 'DE-DE') {
      return 'de';
    }
    if (currentLocale === 'EN-GB') {
      return 'en';
    }
    ;
    return 'de';
  }, [currentLocale]);
  var handleCaptchaChange = useCallback(function (token) {
    setCaptchaToken(token || '');
    if (token) {
      dispatch(dispatchCaptchaSolved());
    }
  }, [dispatch]);
  useEffect(function () {
    var refreshCaptcha = function refreshCaptcha() {
      if (captchaRef.current && captchaToken) {
        captchaRef.current.resetCaptcha();
        setCaptchaToken('');
      }
    };
    var tokenRefreshTimeout = null;
    if (captchaToken) {
      tokenRefreshTimeout = setTimeout(refreshCaptcha, 210000); // 210 seconds
    }
    return function () {
      if (tokenRefreshTimeout) {
        clearTimeout(tokenRefreshTimeout);
      }
    };
  }, [captchaToken, setCaptchaToken]);
  return {
    captchaToken: captchaToken,
    captchaRef: captchaRef,
    handleCaptcha: handleCaptchaChange,
    currentLanguage: currentLanguage
  };
};